/* eslint-disable no-undef */
/* global Swiper */
// import router from '../router';
import {EffectFade, Navigation} from 'swiper';
import helpers from '../helpers';
import analytics from '../analytics';

const isMobile = helpers.isMobile();

Swiper.use([EffectFade, Navigation]);
const speed = 1000;
let initialSlideChange;
let slider;

function counterChange(swiper) {
	const hash = window.location.pathname + window.location.hash;
	analytics.virtualHit(hash);
	if (swiper) {
		swiper.slides.forEach((slide) => {
			if (!slide.classList.contains('swiper-slide-duplicate')) {
				if (slide.classList.contains('swiper-slide-active') || slide.classList.contains('swiper-slide-duplicate-active')) {
					document.querySelector('.intro__slider-counter .count').innerHTML = Number(slide.dataset.swiperSlideIndex) + 1;
				}
			}
		});
	}
}

function clicEvent(swiper) {
	const audio = document.querySelectorAll('.intro__audio .player');
	const introOpinion = document.querySelector('.intro__sidebar.for-desktop .intro__opinion');
	const activeSlide = swiper.el.querySelector('.swiper-slide-active');
	const article = activeSlide.dataset.article;
	// const activeLink = activeSlide.dataset.link;
	const index = activeSlide.dataset.swiperSlideIndex;
	let prevLink = swiper.el.querySelector('.swiper-slide-prev').dataset.link;
	let nextLink = swiper.el.querySelector('.swiper-slide-next').dataset.link;
	const prev = swiper.el.querySelector('.intro__slider-button--prev');
	const next = swiper.el.querySelector('.intro__slider-button--next');
	const counter = swiper.el.querySelector('.intro__slider-counter .counter').textContent;
	const total = swiper.el.querySelector('.intro__slider-counter .total').textContent;

	if (counter === '1') {
		nextLink = '/1';
	}

	if (total === counter) {
		prevLink = `/${total - 2}`;
	}

	console.log(article);

	if (Number.parseInt(article) === 4 || Number.parseInt(article) === 5 || Number.parseInt(article) === 6 || Number.parseInt(article) === 7) {
		let $option = $(introOpinion);

		$option.css({
			pointerEvents: 'none',
		});

		$option.find('.intro__opinion-text').text('Cкоро');
	} else {
		introOpinion.setAttribute('href', `/article/${article}`);

		let $option = $(introOpinion);

		if ($option.find('.intro__opinion-text').text() !== 'Советы эксперта') {
			$option.find('.intro__opinion-text').text('Советы эксперта');
		}
	}

	prev.href = prevLink;
	next.href = nextLink;

	if (audio.length > 1) {
		audio.forEach((element) => {
			element.classList.remove('active');
			if (index === element.dataset.index) {
				element.classList.add('active');
			}
		});
	}
}

function slideChangeAction(swiper) {
	const title = document.querySelector('.intro__content-text h2');
	const box = document.querySelector('.intro__content-hidden');
	let active;
	gsap.to(title, 0.5, {
		y: 100,
		alpha: 0,
		onStart() {
			box.classList.add('hidden');
		},
		onComplete() {
			active = swiper.el.querySelector('.swiper-slide-active').dataset.mainTitle;
			title.textContent = active;
			clicEvent(swiper);
			box.classList.remove('hidden');
		},
		clearProps: 'all',
	});

	ga('send', 'event', 'main', 'slider topic change', `${active}`, {nonInteraction: false});
}

function setTranslate(swiper) {
	swiper.slides.forEach((slide) => {
		const offset = slide.swiperSlideOffset;
		let x = -offset;

		if (!swiper.params.virtualTranslate) {
			x -= swiper.translate;
		}

		let y = 0;

		if (!swiper.isHorizontal()) {
			y = x;
			x = 0;
		}

		gsap.set(slide, {
			x,
			y,
		});
	});
}

function destroy() {
	slider.destroy();
}

function init() {
	if (!isMobile) {
		initialSlideChange = window.location.pathname.slice(1);

		const count = document.querySelectorAll('.intro__content.for-desktop .intro__item').length;
		const duplicate = document.querySelectorAll('.intro__content.for-desktop .swiper-slide-duplicate').length;
		const navigation = document.querySelector('.intro__slider-navigation');

		document.querySelector('.intro__content.for-desktop .intro__slider-counter .total').textContent = count - duplicate;
		document.querySelector('.intro__content.for-desktop .intro__slider-counter .count').textContent = +initialSlideChange + 1;

		if (count <= 1) {
			navigation.classList.add('is-hidden');
		}
		slider = new Swiper('.intro__content.for-desktop .js-intro-slider', {
			loop: true,
			speed,
			effect: 'custom',
			initialSlide: +initialSlideChange,
			simulateTouch: false,
			virtualTranslate: true,
			watchSlidesProgress: true,
			on: {
				init(swiper) {
					clicEvent(swiper);
					const active = swiper.el.querySelector('.swiper-slide-active').dataset.mainTitle;
					const title = $(swiper.el).closest('.page').find('.intro__content-text h2');
					title.text(active);
					const name = title.text();
					ga('send', 'event', 'main', 'show topic', `${name}`, {nonInteraction: true});
				},
				slideChangeTransitionStart(data) {
					setTimeout(() => {
						data.animating = false;
					}, 0);

					data.slides.forEach((slide) => {
						if (slide.querySelector('video')) {
							slide.querySelector('video').pause();
						}
					});
				},
				snapIndexChange(translate) {
					// eslint-disable-next-line no-shadow
					const swiper = this;

					if (swiper.params.effect !== 'custom') {
						return;
					}

					setTranslate(swiper, translate);
				},
			},
		});

		document.querySelector('.intro__slider-button--next').addEventListener('click', () => {
			slider.slideNext();
			counterChange(slider);
			slideChangeAction(slider);
		});
		document.querySelector('.intro__slider-button--prev').addEventListener('click', () => {
			slider.slidePrev();
			counterChange(slider);
			slideChangeAction(slider);
		});
	}
}

export default {
	init,
	destroy,
};
